import React from 'react'
import { useTranslation } from 'react-i18next'
import { Text, Block } from 'suomifi-ui-components'
import {
  FooterContainer,
  FooterRow,
  DvvLogo,
  VerticalRuleDesktop,
  StyledExternalLink,
  ColorBar,
  InnerFooterContainer,
} from 'todistukset-ui/src/vtj/components/footer/Footer.sc'
import { LanguageCode } from 'common/src/vtj/LanguageCode.enum'
import LocalizedString from 'todistukset-ui/src/vtj/components/localized-string/LocalizedString.react'

const assetPath = '/public/assets/'

export interface FooterProps {
  lang: LanguageCode
  feedbackUrl: string
}

const Footer = ({ lang, feedbackUrl }: FooterProps): React.ReactElement => {
  const { t } = useTranslation()
  return (
    <FooterContainer>
      <ColorBar />
      <InnerFooterContainer>
        <FooterRow data-test-id="page-footer">
          <Block>
            <DvvLogo
              src={`${assetPath}images/logo-dvv-white-${lang}.svg`}
              alt={t('dvv')}
            />
          </Block>
          <Block my="m">
            <Text color="whiteBase">
              <LocalizedString stringKey="feedbackGenericInformation" />
            </Text>
            <Block mt="m">
              <StyledExternalLink
                data-test-id="feedback-form-link--link"
                labelNewWindow={t('opensInNewWindow')}
                href={feedbackUrl}
                underline="initial"
              >
                <LocalizedString stringKey="feedbackGiveFeedback" />
              </StyledExternalLink>
            </Block>
          </Block>
          <VerticalRuleDesktop />
          <Block my="m">
            <Text variant="bold" color="whiteBase">
              <LocalizedString stringKey="footerContact" />
            </Text>
            <Block mt="m">
              <StyledExternalLink
                data-test-id="maistraatti-contacts-link"
                labelNewWindow={t('opensInNewWindow')}
                hideIcon
                href={t('footerMagistratesLink')}
                underline="initial"
              >
                <LocalizedString stringKey="footerMagistratesLinkDescription" />
              </StyledExternalLink>
            </Block>
            <Block mt="m">
              <StyledExternalLink
                data-test-id="data-privacy-link"
                labelNewWindow={t('opensInNewWindow')}
                hideIcon
                href={t('footerElsaDataProtectionLinkUrl')}
                underline="initial"
              >
                <LocalizedString stringKey="footerDataProtectionLinkDescription" />
              </StyledExternalLink>
            </Block>
            <Block mt="m">
              <StyledExternalLink
                data-test-id="maistraatti-accessibility-link"
                labelNewWindow={t('opensInNewWindow')}
                hideIcon
                href={t('accessibilityLink')}
                underline="initial"
              >
                <LocalizedString stringKey="footerAccessibilityLinkDescription" />
              </StyledExternalLink>
            </Block>
            <Block mt="m">
              <StyledExternalLink
                data-test-id="cookie-policy-link"
                toNewWindow={false}
                hideIcon
                href={t('cookiePolicyLink')}
                underline="initial"
              >
                <LocalizedString stringKey="footerCookiePolicyLinkDescription" />
              </StyledExternalLink>
            </Block>
          </Block>
        </FooterRow>
      </InnerFooterContainer>
    </FooterContainer>
  )
}

export default Footer
